/* Initialize re-usable variable declarations */
var touchDevice, addOnsWindowWidth, scrollThreshold, toggleHeaderResizeTimeout, menuMobileImprovedClass, navLinkIconStatusClass, slideDownLayout, mouseX, mouseY, slideDownVisible, clickTimeout, specificNavItemSelector, specificNavItemNotSelector, toggleHeaderData, headerContentHeight, smartSearchTimer, searchPlaceholderText, prevSearchInput, essentialTasksComplete;

/* Initialize legacy re-usable variable declarations */
var menuMobileImprovedClassLegacy, mobileDropdownLegacy;

/* Initialize element declarations */
var header, swipedTile, allMenuItems, menuBar, mobileDropdown, activeMenuItem, slideDown, mobileMenuIcons, headerOuter, titleBar, toggleButtonElement, allFeaturedImageSections, allHomepageHeroSections, searchContainers, slideDownMenuBarContainer, allSubMenuItems, allSubSubMenuItems, sectionOuter, menuMobileInnerContainer, mobileMenuFooter, allSearchDropdowns, sliderIds, currentAbortCtrl, searchResultsDisplayed, searchLastOpenedWithMobileMenuOpen, smartSearchActive, smartSearchInitialized, interacted, desktopContentCopiedToMobile, legacyMenuInitialized, legacyMenuInitialized, allIndexSwitchingCompleted, utilityBarSwipers;

var reusableVariablesInitialized = false;

window.Branch = window.Branch || {};
window.Branch.nav = window.Branch.nav || {};

function initToggleHeaderReusableVariableDeclarations(){
    /* Assign values to element declarations */
    if(reusableVariablesInitialized == false){
        header = document.querySelector('.toggle-header');
        if(header){
            allMenuItems = header.querySelectorAll('.toggle-header-menu-bar-container__item');
            allSearchDropdowns = document.querySelectorAll('.toggle-header__smart-search-dropdown-outer');
            menuBar = header.querySelector('.toggle-header__menu-bar');
            slideDown = document.querySelector('.toggle-header__slide-down-container');
            headerOuter = document.querySelector('.toggle-header__outer');
            titleBar = header.querySelector('.toggle-header__title-bar');
            toggleButtonElement = headerOuter.querySelector('.toggle-header-title-bar-container__toggle-dtc-element')
            allFeaturedImageSections = document.querySelectorAll('.custom-feature-image-section .custom-feature-image');
            allHomepageHeroSections = document.querySelectorAll('.homepage-hero-section .homepage-hero');

            sectionOuter = document.querySelector('#shopify-section-header');
            mobileMenuIcons = header.querySelectorAll('.menu-mobile-improved__nav-link');
            mobileDropdown = document.querySelector('.menu-mobile-improved')
            mobileDropdownLegacy = document.querySelector('.menu-mobile-improved-legacy')
            menuMobileInnerContainer = mobileDropdown.querySelector('.menu-mobile-improved__inner-container')
            mobileMenuFooter = mobileDropdown.querySelector('.menu-mobile-improved__footer')

            /* Assign values to re-usable variable declarations */
            touchDevice = window.Branch.functions.isTouchDevice();
            toggleHeaderWindowWidth = window.innerWidth;
            slideDownLayout = headerOuter.getAttribute('data-scroll-down-layout');
            mouseX = 0;
            mouseY = 0;
            isDragging = false;
            slideDownVisible = false;
            searchPlaceholderText = "Search for products, ergonomic support...";
            reusableVariablesInitialized = true;
            menuMobileImprovedClass = 'menu-mobile-improved--STATUS';
            menuMobileImprovedClassLegacy = 'menu-mobile-improved-legacy--STATUS';
            navLinkIconStatusClass = 'menu-mobile-improved__nav-icon--STATUS';
            scrollThreshold = 200;
            specificNavItemSelector = '.menu-mobile-improved__nav-item.menu-mobile-improved__nav-item--has-dropdown[data-item-index="PLACEHOLDER"]';
            specificNavItemNotSelector = `.menu-mobile-improved__nav-item.menu-mobile-improved__nav-item--has-dropdown:not([data-item-index="PLACEHOLDER"])`;
            toggleHeaderData = document.querySelector('#toggle-header-data') ? JSON.parse(document.querySelector('#toggle-header-data').innerText) : {};
            essentialTasksComplete = false;
            sliderIds = [];
            prevSearchInput = '';
            searchResultsDisplayed = false;
            searchLastOpenedWithMobileMenuOpen = false;
            smartSearchActive = true;
            smartSearchInitialized = false;
            legacyMenuInitialized = false;
            interacted = false;
            desktopContentCopiedToMobile = false;
            allIndexSwitchingCompleted = false;
            utilityBarSwipers = {};
        }
    }
}

/* Close all active dropdowns */
const closeAllActiveMenuItems = function(){
    allMenuItems.forEach((menuItem) => {
        if(menuItem.getAttribute('data-active') == 'true' && menuItem.querySelector('.toggle-header-menu-dropdown')){
            menuItem.querySelector('.toggle-header-menu-dropdown .toggle-header-menu-dropdown__outer-container').style.transform = `translateY(-${menuItem.querySelector('.toggle-header-menu-dropdown').offsetHeight}px)`
            menuItem.setAttribute('data-active', false);
        }
    });
    headerOuter.setAttribute('data-dropdown-open', false);
    hideBundleBuilderStickyHeader('closed');
    if(document.querySelector('.collection-filters-mobile-slide-down')){document.querySelector('.collection-filters-mobile-slide-down').setAttribute('data-filters-hidden', false)}
    activeMenuItem = undefined;
}

/* Close all active dropdowns if click outside occurs */
const handleClickOutside = function(e){
    if (activeMenuItem && activeMenuItem.closest('.toggle-header__menu-bar') && !activeMenuItem.closest('.toggle-header__menu-bar').contains(e.target)) {
        let clickOnSearch = false;
        if(smartSearchActive == false){
            searchContainers.forEach((searchContainer) => {
                if(searchContainer.contains(e.target)){
                    clickOnSearch = true;
                }
            })
        }
        if(clickOnSearch == false){
            closeAllActiveMenuItems();
            document.removeEventListener('click', handleClickOutside);
        }
      }
}

window.Branch.nav.handleUpdateSrcSet = function(e, selector, parentSelector, maxWidth) {
    let unUpdatedImages;
    if(e){
        unUpdatedImages = e.target.closest(`${parentSelector}`) && e.target.closest(`${parentSelector}`).querySelectorAll(`${selector}:not([data-srcset-updated="true"])`);
    } else {
        unUpdatedImages = document.querySelectorAll(`${parentSelector} ${selector}:not([data-srcset-updated="true"])`);
    }
    unUpdatedImages.forEach((image) => {
        let src = image.getAttribute('src');
        if(src){
            let srcset = window.Branch.functions.returnSrcSet(src, maxWidth)
            image.setAttribute('srcset', srcset);
            image.setAttribute('data-srcset-updated', 'true');
        }
    });
};

/* Update styling and attributes of clicked-on/hovered-over menu item, in order to show the dropdown menu */
const handleDropdownOpen = function(currentItemDropdown, newActiveStatus, currentItem, e){
    if(interacted == false){
        interacted = true;
        initFunctionsOnInteract()
    };
    if(currentItemDropdown){
        if(e){
            window.Branch.nav.handleUpdateSrcSet(e, '.product-image-container img', '.toggle-header-menu-bar-container__item', 540)
        }       
        let currentItemDropdownOuter = currentItemDropdown.querySelector('.toggle-header-menu-dropdown__outer-container');
        if(newActiveStatus){
            currentItemDropdownOuter.style.transform = `translateY(0)`;
            currentItem.setAttribute('data-active', true)
            activeMenuItem = currentItem;
            headerOuter.setAttribute('data-dropdown-open', true);
            hideBundleBuilderStickyHeader('open');
            if(document.querySelector('.collection-filters-mobile-slide-down')){document.querySelector('.collection-filters-mobile-slide-down').setAttribute('data-filters-hidden', true)}
        }

        if(currentItemDropdown.getAttribute('data-carousels-initialized') == 'false'){
            initProductCarousels(currentItemDropdown, 'regular');
        }

        /* Add 'click outside' event listener to document object */
        if(touchDevice == true && newActiveStatus == true){
            document.addEventListener('click', handleClickOutside);
        }
    }
}

/* Determine of click-on/hover-over menu items should be opened or closed, and update styling/attributes accordingly */
const toggleDropDownVisibility = function(e, targetItem){
    let currentItem = e ? window.Branch.functions.getElementWithClass(e, 'toggle-header-menu-bar-container__item') : targetItem;
    if(currentItem){
        let newActiveStatus = currentItem.getAttribute('data-active') == 'false' ? true : false;
        let currentItemDropdown = currentItem.querySelector('.toggle-header-menu-dropdown');

        headerOuter.setAttribute('data-transitioning', true);
        document.removeEventListener('click', handleClickOutside);

        if(headerOuter.getAttribute('data-dropdown-open') == 'false'){
            currentItem.setAttribute('data-active', newActiveStatus);
            currentItem.querySelector('.toggle-header-menu-bar-container__item-link').setAttribute('aria-expanded', newActiveStatus)    
            handleDropdownOpen(currentItemDropdown, newActiveStatus, currentItem, e);
            setTimeout(function(){
                headerOuter.setAttribute('data-transitioning', false);
            }, 250);
        } else {
            closeAllActiveMenuItems();
            setTimeout(function(){
                currentItem.setAttribute('data-active', newActiveStatus);
                currentItem.querySelector('.toggle-header-menu-bar-container__item-link').setAttribute('aria-expanded', newActiveStatus)        
                handleDropdownOpen(currentItemDropdown, newActiveStatus, currentItem, e);
                setTimeout(function(){
                    headerOuter.setAttribute('data-transitioning', false);
                }, 240);
            }, 10)
        }
        if(headerOuter.getAttribute('data-nav-interacted-with') == 'false'){
            headerOuter.setAttribute('data-nav-interacted-with', true);
            // preLoadCarouselImages();
        }
    }
}

/* Set transform value for all non-active dropdowns, and all search dropdowns */
const updateDropDownTransformValue = function(){
    allMenuItems.forEach((menuItem) => {
        if(menuItem.getAttribute('data-active') == 'false' && menuItem.querySelector('.toggle-header-menu-dropdown')){
            menuItem.querySelector('.toggle-header-menu-dropdown .toggle-header-menu-dropdown__outer-container').style.transform = `translateY(-${menuItem.querySelector('.toggle-header-menu-dropdown').offsetHeight}px)`
        } 
    });

    allSearchDropdowns = document.querySelectorAll('.toggle-header__smart-search-dropdown-outer');
    allSearchDropdowns.forEach((searchDropdown) => {
        if(searchDropdown.closest('.toggle-header-title-bar-container__search-container').getAttribute('data-active') != 'true'){
            if(window.innerWidth < 900){
                let utilityBarHeight = document.querySelector('.toggle-header__utility-bar') && window.scrollY <= scrollThreshold ? document.querySelector('.toggle-header__utility-bar').offsetHeight : -1;
                if(document.querySelector('.toggle-header__utility-bar[data-current="b2b"]')){utilityBarHeight = -1};
                let mobileContentHeight = `${window.innerHeight - utilityBarHeight - 56 - 56}px`;
                searchDropdown.querySelector('.toggle-header__smart-search-dropdown-inner').style.height = mobileContentHeight;
                searchDropdown.querySelector('.toggle-header__smart-search-dropdown-inner').style.transform = `translateY(0) translateX(100%)`;
            } else {
                searchDropdown.querySelector('.toggle-header__smart-search-dropdown-inner').style.transform = `translateY(-${searchDropdown.querySelector('.toggle-header__smart-search-dropdown-inner').offsetHeight + 2}px) translateX(0)`;
            }
        }
    })
}

/* Hide excess nav items if the containing space is too small */
const hideExcessItems = function() {
    let ulElements = headerOuter.querySelectorAll('.toggle-header__slide-down-nav-container>ul, .toggle-header-menu-bar-container>ul');
    ulElements.forEach((ul) => {
        const liElements = Array.from(ul.querySelectorAll('li.toggle-header-menu-bar-container__item'));
        const ulWidth = ul.clientWidth;
    
        let totalWidth = 0;
        
        liElements.forEach(li => {
          totalWidth += li.offsetWidth;
          if (totalWidth <= ulWidth) {
            li.setAttribute('data-hidden', false);
          } else {
            li.setAttribute('data-hidden', true);
          }
        });
    })  
  }

const createStandInNavItems = function(containerSelector, type){
    ['b2b', 'dtc'].forEach((type) => {
        let innerUl = header.querySelector(`.toggle-header-menu-bar-container[data-type="${type}"] > ul`) ? header.querySelector(`.toggle-header-menu-bar-container[data-type="${type}"] > ul`) : slideDown.querySelector(`.toggle-header__slide-down-nav-container[data-type="${type}"]>ul`);
        let clonedInnerUl = innerUl.cloneNode(false);
        
        Array.from(innerUl.children).forEach(child => {
            const button = child.querySelector('button').cloneNode(true); 
            button.setAttribute('aria-hidden', true);
            const listItem = document.createElement('li');
            listItem.appendChild(button);
            clonedInnerUl.appendChild(listItem);
        });

        headerOuter.querySelector(`${containerSelector.replace('DATATYPE', type)}`).appendChild(clonedInnerUl);        
    });

    if(slideDownLayout == 'nav_items_bar_and_header_bar' && type == 'slide-down'){
        let titleBarToClone = header.querySelector('.toggle-header__title-bar');
        let clonedTitleBar = titleBarToClone.cloneNode(true);
       
        clonedTitleBar.querySelector('.toggle-header__smart-search-popular-categories').setAttribute('data-id', 4859328643);
        headerOuter.querySelector(`.toggle-header__slide-down-header`).appendChild(clonedTitleBar);
    }
}

 const triggerMouseEnterOnHoveredItem = function() {
    const hoveredElement = document.elementFromPoint(mouseX, mouseY);
    if (!hoveredElement) return; 
    const targetItem = hoveredElement.closest('.toggle-header-menu-bar-container__item');

    if (targetItem && targetItem.getAttribute('data-active') == 'false') {
        toggleDropDownVisibility(false, targetItem)
    }
  }

const updateBundleStepsHeaderHeights = function(){
    window.Branch.functions.updateHeightInCategory('.toggle-header .toggle-header-menu-dropdown__bundle-steps-outer-container', '.toggle-header .toggle-header-menu-dropdown__bundle-steps-outer-container .toggle-header-menu-dropdown__bundle-step-title')
}

const updateSubMenuItemHeights = function(){
    window.Branch.functions.updateHeightInCategory('.toggle-header-menu-bar-container__submenu[data-sub-menu-items-layout="sub-menu-items-and-sub-sub-menu-items"]', '.toggle-header-menu-bar-container__submenu-item > .toggle-header-menu-bar-container__submenu-item-link')
}

const updateSlideDownStyling = function(){
    slideDown.style.height = slideDownLayout == 'nav_items_bar_and_header_bar' ? `${titleBar.offsetHeight + 60}px` : `${60}px`;
    

    window.Branch.nav.handleToggleHeaderScroll();

    if(slideDown.getAttribute('data-initialized') != 'true'){
        createStandInNavItems(`.toggle-header__slide-down-inner-container[data-type="DATATYPE"]`, 'slide-down');

        if(slideDownLayout != 'nav_items_bar_and_header_bar'){
            let dtcLogoInnerClone = header.querySelector('.toggle-header-title-bar-container__logo-inner a[data-type="dtc"]').cloneNode(true);
            let cartIconClone = header.querySelector('.toggle-header-title-bar-container__utils-inner .cart-wrap').cloneNode(true);

            slideDown.querySelector('.toggle-header__slide-down-logo-container-inner').appendChild(dtcLogoInnerClone);
            slideDown.querySelector('.toggle-header__slide-down-cart-icon-container-inner').appendChild(cartIconClone)
        }

        setTimeout(function(){
            slideDown.setAttribute('data-initialized', true);
        }, 250)
    }
}

const handleMobileNavItemClick = function(e, type, itemIndex){
    if(interacted == false){interacted = true;initFunctionsOnInteract()};
    e.preventDefault();
    let clickStraightThrough = e && e.target && e.target.closest('.menu-mobile-improved__nav-item') ? e.target.closest('.menu-mobile-improved__nav-item').getAttribute('data-skip-dropdown') == 'true' : false; 
    if(clickStraightThrough){
        const currentUrl = window.location.origin;
        window.location.href = `${currentUrl}${e.target.closest('.menu-mobile-improved__nav-item').querySelector('.menu-mobile-improved__nav-item-link').getAttribute('href')}`;
    } else {
        if(headerOuter.getAttribute('data-nav-interacted-with') == 'false'){
            headerOuter.setAttribute('data-nav-interacted-with', true);
            // preLoadCarouselImages();
        }

        if(e){
            window.Branch.nav.handleUpdateSrcSet(e, '.product-image-container img', '.menu-mobile-improved__nav-item', 540)
        }   

        let targetItem = type == 'click_outside' ?  document.querySelectorAll(`${specificNavItemSelector.replace('PLACEHOLDER', '1')}`)[0] : document.querySelectorAll(`${specificNavItemSelector.replace('PLACEHOLDER', `${itemIndex}`)}`)[0];

        if(type !== 'click_outside' && targetItem.getAttribute('data-carousels-initialized') == 'false'){
            initProductCarousels(targetItem, 'regular');
        }

        let value = type == 'click_outside' ? 'open' : targetItem.getAttribute('data-status');
        let index = targetItem.getAttribute('data-item-index');
        let items = document.querySelectorAll(`${specificNavItemSelector.replace('PLACEHOLDER', `${index}`)}`);
        let allOtherItems = document.querySelectorAll(`${specificNavItemNotSelector.replace('PLACEHOLDER', `${index}`)}`);
        let newValue = value == 'closed' ? 'open' : 'closed';

        let utilityBarHeight = document.querySelector('.toggle-header__utility-bar') && window.scrollY <= scrollThreshold ? document.querySelector('.toggle-header__utility-bar').offsetHeight : -1;


        let mobileContentHeight = `${window.innerHeight - utilityBarHeight - 56}px`;

        // console.log('mobileContentHeight', mobileContentHeight)
    
        items.forEach((item) => {
            if(allOtherItems.length > 0) {
                allOtherItems.forEach((singleItem) => {
                    singleItem.classList.remove(`${'menu-mobile-improved__nav-item--PLACEHOLDER'.replace('PLACEHOLDER', 'open')}`);
                    singleItem.classList.add(`${'menu-mobile-improved__nav-item--PLACEHOLDER'.replace('PLACEHOLDER', 'closed')}`);
                    singleItem.setAttribute('data-status', 'closed');
                    
                })
            }

            item.style.pointerEvents = "none";
            item.classList.remove(`${'menu-mobile-improved__nav-item--PLACEHOLDER'.replace('PLACEHOLDER', 'open')}`);
            item.classList.remove(`${'menu-mobile-improved__nav-item--PLACEHOLDER'.replace('PLACEHOLDER', 'closed')}`);
            item.closest('.menu-mobile-improved__nav').style.height = `${newValue == "open" ? mobileContentHeight : 'auto'}`
            item.closest('.menu-mobile-improved__nav').style.overflowY = `${newValue == "open" ? 'hidden' : 'scroll'}`

            mobileMenuFooter.setAttribute('data-transparent', true);

            if(newValue == 'open'){
                item.querySelector('.menu-mobile-improved__nav-item-content-stand-in-wrapper').style.display = 'block';
                setTimeout(function(){
                    document.querySelectorAll('.menu-mobile-improved').forEach((mobileMenuImproved) => {mobileMenuImproved.setAttribute('data-sub-items-status', `${newValue}`)})
                    item.setAttribute('data-status', newValue);
                }, 1)
            } else {
                item.setAttribute('data-status', newValue);
                document.querySelectorAll('.menu-mobile-improved').forEach((mobileMenuImproved) => {mobileMenuImproved.setAttribute('data-sub-items-status', `${newValue}`)})
                setTimeout(function(){
                    item.querySelector('.menu-mobile-improved__nav-item-content-stand-in-wrapper').style.display = 'none';
                }, 250)
            }

            item.classList.add(`${'menu-mobile-improved__nav-item--PLACEHOLDER'.replace('PLACEHOLDER', newValue)}`);                
            setTimeout(function () {
                item.style.pointerEvents = "";
                mobileMenuFooter.setAttribute('data-transparent', false)
                let scrollContainer = item.querySelector('.menu-mobile-improved__nav-item-link-content');
                if (scrollContainer && scrollContainer.scrollTop !== 0) {
                    scrollContainer.scrollTo({ top: 0, behavior: "smooth" });
                }                        
            }, 250);
        });
    }
}

const updateMenuPosition = function(type) {
    let fixedHeaderContentHeight = window.innerWidth > 899 ? 122 : 56;
    let tempUtilityBar = window.innerWidth > 899 ? 31 : 41;

    if(type == 'utility-bar-close'){
        tempUtilityBar = 0;
    }

    if(document.querySelector('.toggle-header__utility-bar[data-current="b2b"]') && window.innerWidth < 900){
        tempUtilityBar = 0;
    }

    headerContentHeight = window.scrollY > fixedHeaderContentHeight ? fixedHeaderContentHeight : fixedHeaderContentHeight - window.scrollY;
    let topPosition = window.scrollY > scrollThreshold ? headerContentHeight - 1 : headerContentHeight + tempUtilityBar;


    mobileDropdown.style.top = `${topPosition}px`;

    /* start of test code remove later */
    if(mobileDropdownLegacy) {
        mobileDropdownLegacy.style.top = `${topPosition}px`;
    }
    /* end of test code remove later */

    updateMobileNavSliderContainerHeight();
};

const updateMobileNavSliderContainerHeight = function(){
    let utilityBarHeight = document.querySelector('.toggle-header__utility-bar') && window.scrollY <= scrollThreshold ? document.querySelector('.toggle-header__utility-bar').offsetHeight : -1;
    
    if(document.querySelector('.toggle-header__utility-bar[data-current="b2b"]') && window.innerWidth < 900){
        utilityBarHeight = -1;
    }
    
    let mobileContentHeight = `${window.innerHeight - utilityBarHeight - 56}px`;

    // console.log('mobileContentHeight', mobileContentHeight)

    document.querySelectorAll('.menu-mobile-improved__nav-item-link-content').forEach((mobileContent) => {
        mobileContent.style.height = mobileContentHeight;
        if(mobileContent.parentElement.querySelector('.menu-mobile-improved__loading-stand-in')){
            mobileContent.parentElement.querySelector('.menu-mobile-improved__loading-stand-in').style.height = mobileContentHeight;
        }
    })

    document.querySelectorAll('.toggle-header__smart-search-dropdown-inner').forEach((smartSearchInner) => {
        if(window.innerWidth < 900){
            smartSearchInner.style.height = `${parseInt(mobileContentHeight.replace('px', '')) - 55}px`;
        } else {
            let contentHeight = smartSearchInner.querySelector('.toggle-header__smart-search-dropdown-column[data-position="left"] .toggle-header__smart-search-dropdown-column-inner').offsetHeight > smartSearchInner.querySelector('.toggle-header__smart-search-dropdown-column[data-position="right"] .toggle-header__smart-search-popular-categories').offsetHeight ? smartSearchInner.querySelector('.toggle-header__smart-search-dropdown-column[data-position="left"] .toggle-header__smart-search-dropdown-column-inner').offsetHeight + 60 : smartSearchInner.querySelector('.toggle-header__smart-search-dropdown-column[data-position="right"] .toggle-header__smart-search-popular-categories').offsetHeight + 60;
            let desktopContentHeight = window.innerHeight - 31 - 60 - 62;
            smartSearchInner.style.height = contentHeight < desktopContentHeight ? 'auto' : `${desktopContentHeight}px`;
        }
    })
}

const updateSearchBarPlaceholder = function(){    
    let truncatedText = window.Branch.functions.truncateText(searchPlaceholderText, window.innerWidth - 120, "16px Quicksand");
    if(searchContainers){
        searchContainers.forEach((searchContainer) => {
            searchContainer.querySelector('input[type="search"]').setAttribute('placeholder', truncatedText);
        })
    }
}

/* Update styling on load and on window-resize */
const updateStyling = function(){
    updateSlideDownStyling();
    updateMenuPosition();
    updateDropDownTransformValue();
    hideExcessItems();
    updateSubMenuItemHeights();
    updateBundleStepsHeaderHeights();
    updateMobileNavSliderContainerHeight();
    updateSearchBarPlaceholder();

    document.querySelectorAll(`.toggle-header__utility-bar:not(.mobile) .swiper`).forEach((utilityBarMessage) => {
        const links = document.querySelector(`.toggle-header__utility-bar:not(.mobile) .utility-bar__links`);
        const linksWidth = links.offsetWidth;

        const calculatedWidth = window.innerWidth - (2 * linksWidth) - (2 * 36);

        // Find the widest .utility-bar__message p child
        let maxMessageWidth = 0;
        utilityBarMessage.querySelectorAll('.utility-bar__message p').forEach((p) => {
            const pWidth = p.offsetWidth;
            if (pWidth > maxMessageWidth) {
                maxMessageWidth = pWidth;
            }
        });

        const messageBasedWidth = maxMessageWidth + 64 + 64;

        // console.log('calculatedWidth', calculatedWidth);
        // console.log('messageBasedWidth', messageBasedWidth);

        const finalWidth = Math.min(calculatedWidth, messageBasedWidth);

        const container = utilityBarMessage.closest('.utility-bar__message-container-outer');
        if(calculatedWidth < messageBasedWidth){
            // console.log('under')
            container.style.left = `${36 + 24}px`;
            utilityBarMessage.style.maxWidth = `${messageBasedWidth - 128 + 48}px`;
        } else {
            // console.log('over')
            container.style.left = `${((window.innerWidth - messageBasedWidth)/2)}px`;
            utilityBarMessage.style.maxWidth = `${finalWidth}px`;
        }
        setTimeout(() => {
            container.setAttribute('data-visible', true);
        }, 500)
    });

} 

const initAllDropDowns = function(){
    allMenuItems.forEach((menuItem) => {
        if(touchDevice != true){
            if(menuItem.getAttribute('data-skip-dropdown') == 'false'){
                menuItem.addEventListener('mouseenter', toggleDropDownVisibility);
                menuItem.addEventListener('mouseleave', toggleDropDownVisibility);
            }
        } else {
            if(menuItem.getAttribute('data-skip-dropdown') == 'false'){
                menuItem.querySelector('.toggle-header-menu-bar-container__item-link').addEventListener('click', toggleDropDownVisibility);
            } else {
                let menuItemButton = menuItem.querySelector('.toggle-header-menu-bar-container__item-link')
                let innerText = menuItemButton.querySelector('span').innerHTML;
                let href = menuItemButton.getAttribute('data-href');
                menuItemButton.innerHTML = `<a href="${href}"><span>${innerText}</span></a><div class="toggle-header-menu-bar-container__item-link-underline"></div>`
            }
        }
    });
    createStandInNavItems(`.toggle-header__main-nav-stand-in-inner-container[data-type="DATATYPE"]`, 'main-nav');

    setTimeout(function(){
        headerOuter.setAttribute('data-initialized', true)
    }, 500); 
}

const toggleHeader = function(e){
    // console.debug('toggle!')
    let toggleContainer = window.Branch.functions.getElementWithClass(e, 'toggle-header-title-bar-container__toggle')
    let toggleElement = window.Branch.functions.getElementWithClass(e, 'toggle-header-title-bar-container__toggle-dtc-element')

    if(toggleElement && toggleContainer){
        let newAttribute = header.getAttribute('data-current') == 'dtc' ? 'b2b' : 'dtc';
        headerOuter.setAttribute('data-transitioning', true);
        toggleContainer.setAttribute('aria-labelledby', `toggle-${newAttribute}-label`);

        // Use fetch to update cart attributes instead of sessionStorage
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                attributes: {
                    user_experience: newAttribute
                }
            })
        })
        .then(response => response.json())
        .catch(error => console.error('Error updating cart attribute:', error));

        header.setAttribute('data-current', `${newAttribute}`);
        document.querySelector('body').setAttribute('data-user-experience', `${newAttribute}`);


        if(window.Branch.homepageHero && window.Branch.homepageHero.swipers && document.querySelector('body.template-index')) {

            if(document.querySelector(`.homepage-content-container[data-type="${newAttribute}"]`)){
                document.querySelector(`.homepage-content-container[data-type="${newAttribute}"]`).setAttribute('aria-hidden', false);
            }

            if(document.querySelector(`.homepage-content-container:not([data-type="${newAttribute}"])`)){
                document.querySelector(`.homepage-content-container:not([data-type="${newAttribute}"])`).setAttribute('aria-hidden', true);
            }

            let sliderIdsToPause = [];
            let sliderIdsToRestart = [];

            document.querySelectorAll('.custom-feature-image').forEach((featureImage) => {
            const container = featureImage.closest('.homepage-content-container');
            if (!container) return;

            const type = container.getAttribute('data-type');
            const id = featureImage.closest('.shopify-section').id;

            if (type === newAttribute) {
                sliderIdsToRestart.push(id);
            } else {
                sliderIdsToPause.push(id);
            }
            console.log('sliderIdsToRestart', sliderIdsToRestart);
            console.log('sliderIdsToPause', sliderIdsToPause);
            for(i=0; i < 2; i++){
                let ids = i == 0 ? sliderIdsToPause : sliderIdsToRestart;
                if(ids.length > 0){
                    ids.forEach((id) => {
                        if(window.Branch.homepageHero.swipers[`${id}`]){
                            if(i == 0){
                                window.Branch.homepageHero.swipers[`${id}`].update(); 
                                window.Branch.homepageHero.swipers[`${id}`].autoplay.start();
                            } else {
                                window.Branch.homepageHero.swipers[`${id}`].autoplay.stop();
                            }
                        }
                    })
                }
            }

            });
        }

        if(mobileDropdown){mobileDropdown.setAttribute('data-current', `${newAttribute}`)}
        if(document.querySelector('.toggle-header__utility-bar.mobile')){document.querySelector('.toggle-header__utility-bar.mobile').setAttribute('data-current', `${newAttribute}`)}
        
        // Keep this for backward compatibility during transition
        sessionStorage.setItem('toogleHeaderState', `${newAttribute}`);
        
        allFeaturedImageSections.forEach((featuredImageSection) => {
            featuredImageSection.setAttribute('data-header-state-current', `${newAttribute}`);
        })

        allHomepageHeroSections.forEach((homepageHeroSection) => {
            homepageHeroSection.setAttribute('data-header-state-current', `${newAttribute}`);
        })
        
        header.querySelectorAll(`.toggle-header-menu-bar-container[data-type="${newAttribute}"]`).forEach((currentMenuBar) => {
            currentMenuBar.setAttribute('aria-hidden', false)
        })
        
        header.querySelectorAll(`.toggle-header-menu-bar-container:not([data-type="${newAttribute}"])`).forEach((hiddenMenuBar) => {
            hiddenMenuBar.setAttribute('aria-hidden', true)
        });

        updateDropDownTransformValue();
        updateMenuPosition();

        if(document.querySelector('body.template-index') && allIndexSwitchingCompleted == false){     
            if(newAttribute == 'b2b' && !document.querySelector('.homepage-content-container[data-type="b2b"]')){
                allIndexSwitchingCompleted = true;
                window.Branch.index.homepageContentFetch('switch', newAttribute);
            } else if (newAttribute == 'dtc' && !document.querySelector('.homepage-content-container[data-type="dtc"]')){
                allIndexSwitchingCompleted = true;
                window.Branch.index.homepageContentFetch('switch', newAttribute);
            }
        }

        if(document.querySelector('body.template-index')){     
            window.dispatchEvent(new Event('scroll', { bubbles: true, cancelable: true }));
        }

        setTimeout(function(){
            headerOuter.setAttribute('data-transitioning', false);
            updateSubMenuItemHeights();
            closeAllSearchContainers();
            closeAllActiveMenuItems();
            updateBundleStepsHeaderHeights();
        }, 500)
    }
}

const closeAllSearchContainers = function(){
    if(headerOuter.getAttribute('data-main-search-bar-visible') == 'true' || headerOuter.getAttribute('data-slide-down-search-bar-visible') == 'true') {
        searchContainers.forEach((searchContainer) => {
            searchContainer.querySelector('.toggle-header__smart-search-dropdown-outer').style.removeProperty('box-shadow'); 
        });
        if(searchLastOpenedWithMobileMenuOpen == true){
            window.Branch.nav.handleNavLinkClick();
        }
        setTimeout(function(){
            
        searchContainers.forEach((searchContainer) => {
            if(window.innerWidth < 900){
                searchContainer.querySelector('.toggle-header__smart-search-dropdown-inner').style.transform = `translateY(0) translateX(100%)`
            } else {
                searchContainer.querySelector('.toggle-header__smart-search-dropdown-inner').style.transform = `translateY(-${searchContainer.querySelector('.toggle-header__smart-search-dropdown-outer').offsetHeight}px) translateX(0)`
            }
        });

        if(mobileDropdown.getAttribute('data-status') == 'closed'){
            document.querySelector('html').style.overflow = `` 
            document.querySelector('html').removeAttribute('data-menu-open');
        }

        searchContainers.forEach((searchContainer) => {
            searchContainer.setAttribute('data-show-icons', false);
        })
       
        setTimeout(function(){
            searchContainers.forEach((searchContainer) => {
                searchContainer.setAttribute('data-active', false);
            })
          headerOuter.setAttribute('data-transitioning', true);
          if(headerOuter.getAttribute('data-dropdown-open') == 'false'){
            menuBar.style.overflow = 'hidden';
          }
          setTimeout(function(){
              headerOuter.setAttribute('data-transitioning', false);
              headerOuter.setAttribute('data-main-search-bar-visible', false);
              headerOuter.setAttribute('data-slide-down-search-bar-visible', false);
              setTimeout(function(){
                  menuBar.style.overflow = 'visible';
                  slideDownMenuBarContainer.style.overflow = 'visible';
                  hideBundleBuilderStickyHeader('closed');
                  if(document.querySelector('.collection-filters-mobile-slide-down')){document.querySelector('.collection-filters-mobile-slide-down').setAttribute('data-filters-hidden', false)}
              }, 250)
          }, 250)
        }, 250);
    }, 100);
    }
}

const searchButtonOnClick = function(event, searchButton, searchInput, searchContainer, type){
        closeAllActiveMenuItems();
        hideBundleBuilderStickyHeader('open');
        initSearchDropDown();
          if (searchContainer.getAttribute('data-active') !== 'true') {
            setTimeout(function(){
                let searchButtonPosition = searchButton.closest('.toggle-header__slide-down-container') ? 'slide-down' : 'main';
                let dropdownOpen = false;

                event.preventDefault(); 
                headerOuter.setAttribute('data-transitioning', true);
                if(searchButtonPosition == 'main'){
                    headerOuter.setAttribute('data-main-search-bar-visible', true);
                    if(headerOuter.getAttribute('data-dropdown-open') == 'false'){
                        menuBar.style.overflow = 'hidden';
                    }
                } else {
                    headerOuter.setAttribute('data-slide-down-search-bar-visible', true);
                    if(document.querySelector('.collection-filters-mobile-slide-down')){document.querySelector('.collection-filters-mobile-slide-down').setAttribute('data-filters-hidden', true)}
                    if(headerOuter.getAttribute('data-dropdown-open') == 'false'){
                        slideDownMenuBarContainer.style.overflow = 'hidden';
                    }
                }
                setTimeout(function(){
                    searchContainer.setAttribute('data-active', true); 
                    document.querySelector('html').style.overflow = `hidden` 
                    document.querySelector('html').setAttribute('data-menu-open', true);
                    searchInput.focus();
                    headerOuter.setAttribute('data-transitioning', false);

                    setTimeout(function(){
                        searchContainer.setAttribute('data-show-icons', true);
                        menuBar.style.overflow = 'visible';
                        searchContainer.querySelector('.toggle-header__smart-search-dropdown-inner').style.transform = `translateY(0) translateX(0)`; 
                        setTimeout(function(){
                                let status = document.querySelector('.menu-mobile-improved').getAttribute('data-status'); 
                                if(status == 'open' && smartSearchActive){
                                    window.Branch.nav.handleNavLinkClick('click outside');
                                    searchLastOpenedWithMobileMenuOpen = true;
                                }
                                searchContainer.querySelector('.toggle-header__smart-search-dropdown-outer').style.boxShadow = `0 1.5em 1.5em #0000000d`; 
                                if(searchContainer.contains(event.target) || type == 'fromLegacyNav'){
                                    searchContainer.querySelector('input[type="search"]').focus();
                                }
                        }, 100)
                    }, 250)
                }, 240)
            }, 10);
          }
}

const initSearchButton = function(){
    searchContainers = headerOuter.querySelectorAll('.toggle-header-title-bar-container__search-container')
    slideDownMenuBarContainer = headerOuter.querySelector('.toggle-header__slide-down-menu-bar-container')
    
    searchContainers.forEach((searchContainer) => {
        const searchButton = searchContainer.querySelector('button[type="button"]:not(.toggle-header__close-search-bar)');
        const searchInput = searchContainer.querySelector('input');

        searchButton.addEventListener('click', function(event) {
            if(smartSearchInitialized == false){
                initSmartSearch();
                searchButtonOnClick(event, searchButton, searchInput, searchContainer);
            } else {
                searchButtonOnClick(event, searchButton, searchInput, searchContainer);
            }
            
        });
    });
    let legacyNavInput = document.querySelector('.menu-mobile-improved-legacy__nav input[type=text].input-search');

    if(legacyNavInput){
        legacyNavInput.addEventListener('click', function(event) {
            let searchContainer = headerOuter.querySelector('.toggle-header__slide-down-container[data-active="true"]') ? headerOuter.querySelector('.toggle-header__slide-down-container[data-active="true"] .toggle-header-title-bar-container__search-container') : headerOuter.querySelector('.toggle-header .toggle-header-title-bar-container__search-container');
            let searchButton = searchContainer.querySelector('button[type="button"]:not(.toggle-header__close-search-bar)');
            const searchInput = searchContainer.querySelector('input');
            if(smartSearchInitialized == false){
                initSmartSearch();
                searchButtonOnClick(event, searchButton, searchInput, searchContainer, 'fromLegacyNav');
            } else {
                searchButtonOnClick(event, searchButton, searchInput, searchContainer, 'fromLegacyNav');
            }
        });
    }

    document.addEventListener('click', function(event) {
        let clickOnSearchButton = false;
        let clickOutside = true;
        let clickOnCloseButton = false;

        searchContainers.forEach((searchContainer) => {
            const searchButton = searchContainer.querySelector('button[type="button"]:not(.toggle-header__close-search-bar)');
            const closeButton = searchContainer.querySelector('button[type="button"].toggle-header__close-search-bar');
    
            if(searchContainer.contains(event.target)){
                clickOutside = false;
            }

            if(closeButton.contains(event.target)){
                clickOnCloseButton = true;
            }

            if(searchButton.contains(event.target)){
                clickOnSearchButton = true;
            }
        })

        if(clickOnSearchButton == false){
            if (clickOutside == true) {
                closeAllSearchContainers();
            } else if(clickOnCloseButton == true) {
                if(searchResultsDisplayed == true){
                    searchContainers.forEach((searchContainer, index) => {
                        let input = searchContainer.querySelector('input[type="search"]');
                        input.value = '';
                        if(index == 0){input.dispatchEvent(new Event('input', { bubbles: true }))};
                    })
                 } else {
                    closeAllSearchContainers();
                 }
            }
        } else {
            if(headerOuter.getAttribute('data-main-search-bar-visible') == 'true' || headerOuter.getAttribute('data-slide-down-search-bar-visible') == 'true'){
                closeAllSearchContainers();
            }
        }
      });
    updateSearchBarPlaceholder();
}

const initToggleElement = function(){
    let primaryToggleElement = document.querySelector('.toggle-header-title-bar-container__toggle-container')
    let mobileToggleContainer = document.querySelector(".menu-mobile-improved__nav-toggle-container");
    if(primaryToggleElement && mobileToggleContainer){
        const clonedToggle = primaryToggleElement.cloneNode(true);
        mobileToggleContainer.appendChild(clonedToggle);
    }

    let toggleButtonElements = document.querySelectorAll('.toggle-header-title-bar-container__toggle-dtc-element');
    toggleButtonElements.forEach((toggleButtonElement) => {
        toggleButtonElement.addEventListener('click', toggleHeader);
    });
    
    // Get the current header state from data-current attribute (set in liquid from cart attributes)
    const currentHeaderState = header.getAttribute('data-current') || 'dtc';
    
    allFeaturedImageSections.forEach((featuredImageSection) => {
        featuredImageSection.setAttribute('data-header-state-current', currentHeaderState);
    });

    allHomepageHeroSections.forEach((homepageHeroSections) => {
        homepageHeroSections.setAttribute('data-header-state-current', currentHeaderState);
    });
}

const handleMouseMove = function(event, first){
    mouseX = event.clientX;
    mouseY = event.clientY;
    if(first == true){
        triggerMouseEnterOnHoveredItem();
    }
}

const returnSwiperParams = function(type, nextElSelector, prevElSelector){
    let params = {
        spaceBetween: 24,
        slidesPerView: 1.66666,
        freeMode: false,
        autoplay: false,
        breakpoints: {
            600: {
                slidesPerView: 2.6666,
                spaceBetween: 24,
                freeMode: false,
                autoplay: false,
            },
            900: {
                slidesPerView: type == 'search-results' ? 3 : type == 'search' ? 2.33333 : 1.33333,
                spaceBetween: 24,
                freeMode: false,
                autoplay: false,
                navigation: {
                    nextEl: nextElSelector,
                    prevEl: prevElSelector,
                },
            },
            1024: {
                slidesPerView: type == 'search-results' ? 3 : 2.33333,
                spaceBetween: 24,
                freeMode: false,
                autoplay: false,
                navigation: {
                    nextEl: nextElSelector,
                    prevEl: prevElSelector,
                },
            },
            1200: {
                slidesPerView: type == 'search-results' ? 4 : 3,
                spaceBetween: 24,
                freeMode: false,
                autoplay: false,
                navigation: {
                    nextEl: nextElSelector,
                    prevEl: prevElSelector,
                },
            }
        },
        on: {
            touchStart(swiper, event) {
                swiper.startX = event.touches ? event.touches[0].clientX : event.clientX;
                swiper.startY = event.touches ? event.touches[0].clientY : event.clientY;
                swiper.isClick = true; 
            },
            init(swiper, event) {
                if(type == "search"){
                    let next = document.querySelector(`${nextElSelector}`);
                    let prev = document.querySelector(`${prevElSelector}`);
                   if(next){
                        next.classList.remove('swiper-button-lock');
                        next.classList.remove('swiper-button-disabled');
                    };
                   if(prev){prev.classList.remove('swiper-button-lock')};
                }
              },
            touchMove(swiper, event) {
                const currentX = event.touches ? event.touches[0].clientX : event.clientX;
                const currentY = event.touches ? event.touches[0].clientY : event.clientY;
                const diffX = Math.abs(currentX - swiper.startX);
                const diffY = Math.abs(currentY - swiper.startY);
            
                if (diffY < diffX) {
                    swiper.isClick = false;
                }
            },
            touchEnd(swiper, event) {
              if (swiper.isClick) {
                const targetElement = event.target.closest(`${type == "search" ? '.toggle-header__smart-search-popular-categories-item-link' : type == 'regular' ? '.product-tile__main-link' : '.product-tile__main-link'}`);
                
                if (!targetElement) return;
                let isSwipeUpDown = swipedTile && swipedTile.dataset.isSwipeUpDown === "true" ? true : false
                if (targetElement.tagName === 'A' && isSwipeUpDown == false) {
                    window.location.href = targetElement.href;
                } 
              }
              if(swipedTile){
                swipedTile = undefined;
              }
            }
        }
    };
    return params;
}

const toggleHeaderDebounce = function(func, wait) {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}

const initProductCarousels = function(parent, type){
    let productCarousels = type == 'search' ? parent.querySelectorAll('.toggle-header__smart-search-popular-categories') : parent.querySelectorAll('.toggle-header-products-list__inner-container');
    if(productCarousels.length > 0 && productCarousels[0]){
        parent.setAttribute('data-carousels-initialized', true);
    }


    productCarousels.forEach((productCarousel) => {
        let productCarouselId = productCarousel.getAttribute('data-id');

        if(sliderIds.includes(productCarouselId)){
            productCarouselId = `${Math.floor(100000 + Math.random() * 900000)}`;
            productCarousel.setAttribute('data-id', productCarouselId)
            sliderIds.push(productCarouselId)
        } else {
            sliderIds.push(productCarouselId)
        }

        let nextElSelector = type == 'search' ? `.toggle-header__smart-search-popular-categories[data-id="${productCarouselId}"] .toggle-header__smart-search-popular-categories__nav-right` : `.toggle-header-products-list__inner-container[data-id="${productCarouselId}"] .toggle-header-products-list__nav-right`;
        let prevElSelector = type == 'search' ? `.toggle-header__smart-search-popular-categories[data-id="${productCarouselId}"] .toggle-header__smart-search-popular-categories__nav-left` : `.toggle-header-products-list__inner-container[data-id="${productCarouselId}"] .toggle-header-products-list__nav-left`;
        
        let params = returnSwiperParams(type, nextElSelector, prevElSelector);

        var toggleHeaderSwiper = new Swiper(`${type == 'search' ? `.toggle-header__smart-search-popular-categories[data-id="${productCarouselId}"] .toggle-header__smart-search-popular-categories-carousel` : `.toggle-header-products-list__inner-container[data-id="${productCarouselId}"] .toggle-header-products-list__carousel`}`, params);
    })
}

const initLinkHoverListeners = function(){
    allSubMenuItems = headerOuter.querySelectorAll('.toggle-header-menu-bar-container__submenu-item');
    allSubSubMenuItems = headerOuter.querySelectorAll('.toggle-header-menu-bar-container__sub-submenu-item');

    allSubMenuItems.forEach((subMenuItem) => {
        subMenuItem.addEventListener('mouseenter', () => {
            let parentDropDown = subMenuItem.closest('.toggle-header-menu-dropdown');
            parentDropDown.setAttribute('data-hovered-sub-link', `${subMenuItem.getAttribute('data-handle')}`);
            
            /* Single click don't follow href, double click follow href */
            if(touchDevice){
                subMenuItem.querySelector('a').addEventListener('click', (event) => {
                    if (clickTimeout) {
                        clearTimeout(clickTimeout); 
                        clickTimeout = null; 
                      } else {
                        event.preventDefault();   
                        clickTimeout = setTimeout(() => {
                          clickTimeout = null; 
                        }, 300); 
                      }
                });   
            }

            if(subMenuItem.getAttribute('data-has-dropdown') == 'false'){
                parentDropDown.setAttribute('data-hovered-link-has-dropdown', false);
            } else {
                parentDropDown.setAttribute('data-hovered-link-has-dropdown', true);
            }
        })
    })
}

const checkBusinessParam = function() {
    const urlParams = new URLSearchParams(window.location.search);
  
    if (urlParams.get('business') === 'true') {
        // Only change if not already b2b
        if (header.getAttribute('data-current') !== 'b2b') {
            const ssClickEvent = new MouseEvent('click', {
                bubbles: true,
                cancelable: true
            });
            toggleButtonElement.dispatchEvent(ssClickEvent);
        } else {
            // Still ensure cart attribute is set correctly, even if we don't toggle the UI
            fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    attributes: {
                        user_experience: 'b2b'
                    }
                })
            })
            .then(response => response.json())
            .catch(error => console.error('Error updating cart attribute:', error));
        }
    }
}
  
const initRichTextLinks = function(){
    let allRichTextLinks = headerOuter.querySelectorAll('.toggle-header-menu-dropdown__rich-text a');
    allRichTextLinks.forEach((link) => {
        let href = link.getAttribute('href');
        if(href.includes('business=true') && href.includes('pages') == false ){
            link.addEventListener('click', function(event) {
                event.preventDefault();
                const url = new URL(window.location);

                if (!url.searchParams.has('business')) {
                  url.searchParams.append('business', 'true');
                }

                window.history.pushState({}, '', url);
                
                // Only toggle if not already b2b
                if (header.getAttribute('data-current') !== 'b2b') {
                    checkBusinessParam();
                } else {
                    // Still ensure cart attribute is set correctly
                    fetch('/cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            attributes: {
                                user_experience: 'b2b'
                            }
                        })
                    })
                    .then(response => response.json())
                    .catch(error => console.error('Error updating cart attribute:', error));
                }
              });
        }
    })
}

const initTopLevelAnchorTags = function(){
    let allTopLevelButtons = headerOuter.querySelectorAll('button.toggle-header-menu-bar-container__item-link:not([data-href="#"])');
    allTopLevelButtons.forEach((allTopLevelButton) => {
        let innerText = allTopLevelButton.querySelector('span').innerHTML;
        let href = allTopLevelButton.getAttribute('data-href');
        allTopLevelButton.innerHTML = `<a href="${href}"><span>${innerText}</span></a><div class="toggle-header-menu-bar-container__item-link-underline"></div>`
    })
}

const repositionNavItems = function(intoSlideDown, result){
    let innerUlDTC;
    let newContainerDTC;
    let oldContainerDTC; 

    let innerUlB2B;
    let newContainerB2B;
    let oldContainerB2B; 
    
    if(intoSlideDown){
        innerUlDTC = header.querySelector(`.toggle-header-menu-bar-container[data-type="dtc"] > ul`);
        newContainerDTC = slideDown.querySelector('.toggle-header__slide-down-nav-container[data-type="dtc"]');  
        oldContainerDTC = header.querySelector(`.toggle-header-menu-bar-container[data-type="dtc"]`);

        innerUlB2B = header.querySelector(`.toggle-header-menu-bar-container[data-type="b2b"] > ul`);
        newContainerB2B = slideDown.querySelector('.toggle-header__slide-down-nav-container[data-type="b2b"]');  
        oldContainerB2B = header.querySelector(`.toggle-header-menu-bar-container[data-type="b2b"]`);
    } else {
        innerUlDTC = slideDown.querySelector('.toggle-header__slide-down-nav-container[data-type="dtc"] > ul');
        newContainerDTC = header.querySelector(`.toggle-header-menu-bar-container[data-type="dtc"]`);
        oldContainerDTC = slideDown.querySelector('.toggle-header__slide-down-nav-container[data-type="dtc"]')

        innerUlB2B = slideDown.querySelector('.toggle-header__slide-down-nav-container[data-type="b2b"] > ul');
        newContainerB2B = header.querySelector(`.toggle-header-menu-bar-container[data-type="b2b"]`);
        oldContainerB2B = slideDown.querySelector('.toggle-header__slide-down-nav-container[data-type="b2b"]')
    }

    if(innerUlDTC && newContainerDTC && oldContainerDTC) {
        newContainerDTC.appendChild(innerUlDTC);
        oldContainerDTC.innerHTML = '';
    }

    if(innerUlB2B && newContainerB2B && oldContainerB2B) {
        newContainerB2B.appendChild(innerUlB2B);
        oldContainerB2B.innerHTML = '';
    }

    slideDown.setAttribute('data-active', `${result}`);
    menuBar.setAttribute('data-stand-in-open', `${result}`);
    hideExcessItems();
}

const displayHideToast = function() {
    let toastElements = headerOuter.querySelectorAll('.toggle-header-title-bar-container__toggle-toast-container');
    let headerToggleToastShown = sessionStorage.getItem('headerToggleToastShown') && sessionStorage.getItem('headerToggleToastShown') == 'true';

    if (headerToggleToastShown) {
        toastElements.forEach((toastElement) => {
            toastElement.style.display = 'none';
        });
    } else {
        toastElements.forEach((toastElement) => {
            let delay = parseInt(toastElement.getAttribute('data-loading-delay'))
            let duration = parseInt(toastElement.getAttribute('data-display-duration'))
            setTimeout(() => {
                toastElement.setAttribute('data-display', true)
                setTimeout(() => {
                    toastElement.setAttribute('data-display', false);
                    setTimeout(() => {
                        toastElement.style.display = 'none';
                        sessionStorage.setItem('headerToggleToastShown', 'true');
                    }, 250); 
                }, duration * 1000); 
            }, delay * 1000);
        })
    }
}

const tempReduceTransitionDuration = function(){
    titleBar.parentElement.setAttribute('data-speed-up-transition', true)
    setTimeout(function(){
        titleBar.parentElement.setAttribute('data-speed-up-transition', false)
    }, 500)
}

const preLoadCarouselImages = function(){
    window.Branch.product.preloadImages(undefined, 'click', 'toggle-header', undefined);
}

const toggleFromSessionHistory = function() {
    const urlParams = new URLSearchParams(window.location.search);

    // Check for the "business=true" query parameter
    if (urlParams.get('business') === 'true') {
        // Always set to b2b when business=true in URL
        if (header.getAttribute('data-current') !== 'b2b') {
            const ssClickEvent = new MouseEvent('click', {
                bubbles: true,
                cancelable: true
            });
            tempReduceTransitionDuration();
            toggleButtonElement.dispatchEvent(ssClickEvent);
        } else {
            // Still ensure cart attribute is set correctly, even if we don't toggle the UI
            fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    attributes: {
                        user_experience: 'b2b'
                    }
                })
            })
            .then(response => response.json())
            .catch(error => console.error('Error updating cart attribute:', error));
        }
    } else {
        // No business parameter in URL, use cart attribute or session storage
        if (header.getAttribute('data-current') !== 'b2b') {
            let prevState = sessionStorage.getItem('toogleHeaderState');
            if (prevState && prevState === 'b2b') {
                const ssClickEvent = new MouseEvent('click', {
                    bubbles: true,
                    cancelable: true
                });
                tempReduceTransitionDuration();
                toggleButtonElement.dispatchEvent(ssClickEvent);
            } else if (!prevState || (prevState && prevState !== 'b2b')) {
                checkBusinessParam();
            }
        }
    }
};
/* Product page overlapping logic */
const productPageStickyAtcCheck = function(){
    let staticATC = document.querySelector(".main-product__atc-container");
    let bulkDiscountsOpen = document.querySelector('.bulk-discounts-dropdown--open');

    if (staticATC && document.querySelector('body').classList.contains('templateProduct') && !bulkDiscountsOpen) {
        let atcOffScreen = window.Branch.functions.isElementVisibleOrBelow('.main-product__atc-container #atc-cta');
        if(atcOffScreen){
            sectionOuter.setAttribute('data-atc-visible', true);
        } else {
            sectionOuter.setAttribute('data-atc-visible', false);
        }
    }
}

const hideBundleBuilderStickyHeader = function(newStatus){
    let bundleBuilderSlideDownPricing = document.querySelector('.bundle-builder__slide-down-pricing');
    if(newStatus == 'open'){
        if(document.querySelector('.bundle-builder__slide-down-pricing-inner')){
            document.querySelector('.bundle-builder__slide-down-pricing-inner').style.opacity = 0;
            setTimeout(() => {
                document.querySelector('.bundle-builder__slide-down-pricing-inner').style.display = 'none';
                bundleBuilderSlideDownPricing.style.display = 'none'
            }, 250)    
        }
    } else {
        if (window.scrollY > scrollThreshold) {
            const result = window.Branch.functions.isElementPartiallyOffScreen('.toggle-header__menu-bar');
            if (result) {
                if(document.querySelector('.bundle-builder__slide-down-pricing-inner')){
                    setTimeout(() => {
                        document.querySelector('.bundle-builder__slide-down-pricing-inner').style.display = 'flex';
                        bundleBuilderSlideDownPricing.style.display = 'block'
                        setTimeout(() => {
                            document.querySelector('.bundle-builder__slide-down-pricing-inner').style.opacity = 1;
                        }, 1) 
                    }, 250)       
                }
            }
        }
    }
}

window.Branch.nav.handleNavLinkClick = function(type){
    let navLinks = document.querySelectorAll('.menu-mobile-improved__nav-link');
    let menu = document.querySelector('.menu-mobile-improved');
    searchLastOpenedWithMobileMenuOpen = false;



    let newStatus = menu.getAttribute('data-status') == 'closed' ? 'open' : 'closed'; 

    if(type == 'click outside') {
        newStatus = 'closed'
    };

    let html = document.querySelector('#page').closest('html');
    if(newStatus == 'open'){
        html.style.overflow = `hidden` 
        html.setAttribute('data-menu-open', true);
    } else {
        html.style.overflow = `` 
        html.removeAttribute('data-menu-open');
    }
 
    // console.log('newStatus', newStatus, document.querySelectorAll('.bundle-builder__slide-down-pricing-inner'))
    
    hideBundleBuilderStickyHeader(newStatus);
    if(newStatus == 'open'){
        document.querySelectorAll('#fc_frame').forEach((fcFrame) => {fcFrame.style.height = '0'; fcFrame.style.minHeight = '0'; fcFrame.style.overflow = 'hidden';});
        if(document.querySelector('.collection-filters-mobile-slide-down')){document.querySelector('.collection-filters-mobile-slide-down').setAttribute('data-filters-hidden', true)}
    } else {
        document.querySelectorAll('#fc_frame').forEach((fcFrame) => {fcFrame.style.removeProperty('height');fcFrame.style.removeProperty('minHeight');fcFrame.style.removeProperty('overflow');});
        setTimeout(function(){if(document.querySelector('.collection-filters-mobile-slide-down')){document.querySelector('.collection-filters-mobile-slide-down').setAttribute('data-filters-hidden', false)}}, 500);
    }

    const handleMenuAnimation = function() {
        const menuMobileImproved = document.querySelector('.menu-mobile-improved');
        const currentDataAttribute = menuMobileImproved ? menuMobileImproved.getAttribute('data-current') : null;
        if (currentDataAttribute) {
            const navItems = document.querySelectorAll(`.menu-mobile-improved__nav-toggle-container, .menu-mobile-improved__nav-item[data-item-type="${currentDataAttribute}"], .menu-mobile-improved__footer-ctas-container, .menu-mobile-improved__additional-links-container .menu-mobile-improved__utility-link, .menu-mobile-improved__footer .menu-mobile-improved__additional-links-container .utility-bar__link, .menu-mobile-improved__nav > .menu-mobile-improved__footer .menu-mobile-improved__footer-links-container`);
            document.body.style.pointerEvents = 'none';
            if (newStatus === 'open') {
                menu.setAttribute('data-transitioning', true);
                menu.classList.remove(`${menuMobileImprovedClass.replace('STATUS', 'closed')}`);
                menu.setAttribute('data-status', `${newStatus}`);
                menu.classList.add(`${menuMobileImprovedClass.replace('STATUS', newStatus)}`);
                setTimeout(() => {
                
                navItems.forEach((item, index) => {
                    item.style.transform = 'translateY(20px)';
                    item.style.opacity = '0';
                    item.style.transition = 'transform 0.25s ease-out, opacity 0.25s ease-out';
                    setTimeout(() => {
                        if (index === 0) {
                            menu.setAttribute('data-transitioning', false);
                            document.body.style.pointerEvents = '';
                        }
                        item.style.transform = 'translateY(0)';
                        item.style.opacity = '1';
                        if (index === navItems.length - 1) {    
                            setTimeout(() => {
                                navItems.forEach(navItem => {
                                    navItem.style.removeProperty('transform');
                                    navItem.style.removeProperty('opacity');
                                    navItem.style.removeProperty('transition');
                                });
                                if(menu.getAttribute('data-nav-content-automatically-closed')) {
                                    let itemToOpen =  menu.querySelector(`.menu-mobile-improved__nav-item[data-menu-name="${menu.getAttribute('data-nav-content-automatically-closed')}"]`);
                                    menu.removeAttribute('data-nav-content-automatically-closed');
                                    console.log('itemToOpen', itemToOpen)
                                    if(itemToOpen){
                                        itemToOpen.classList.remove('menu-mobile-improved__nav-item--closed');
                                        itemToOpen.classList.add('menu-mobile-improved__nav-item--open');
                                        itemToOpen.setAttribute('data-status', 'open');
                                    }
                                }

                            }, 300);
                        } 
                    }, (index * 50) + 250);
                });
                }, 250);
            } else {
                console.log('start closing animation')

                let delayForClosingOpenLinkContent = 1;
                const hasOpenItem = Array.from(navItems).some(item => item.getAttribute('data-status') === 'open');
                if (hasOpenItem) {
                    delayForClosingOpenLinkContent = 250;

                    let firstOpenItemMenuName = null;

                    navItems.forEach(item => {
                        if (item.getAttribute('data-status') === 'open' && firstOpenItemMenuName === null) {
                            firstOpenItemMenuName = item.getAttribute('data-menu-name');
                        }
                        item.classList.remove('menu-mobile-improved__nav-item--open');
                        item.classList.add('menu-mobile-improved__nav-item--closed');
                        item.setAttribute('data-status', 'closed');
                    });

                    if (firstOpenItemMenuName) {
                        menu.setAttribute('data-nav-content-automatically-closed', firstOpenItemMenuName);
                    }
                }

                setTimeout(function(){
                    const reverseItems = Array.from(navItems).reverse();
                    reverseItems.forEach((item, index) => {
                        item.style.transition = 'transform 0.25s ease-out, opacity 0.25s ease-out';
                        setTimeout(() => {
                            item.style.transform = 'translateY(20px)';
                            item.style.opacity = '0';
                            if (index === reverseItems.length - 1) {
                                menu.setAttribute('data-transitioning', true);
                                setTimeout(() => {
                                    menu.classList.remove(`${menuMobileImprovedClass.replace('STATUS', 'open')}`);
                                    menu.setAttribute('data-status', `${newStatus}`);
                                    menu.classList.add(`${menuMobileImprovedClass.replace('STATUS', newStatus)}`);
                                    setTimeout(() => {  
                                        menu.setAttribute('data-transitioning', false);
                                        document.body.style.pointerEvents = '';
                                        navItems.forEach(navItem => {
                                            navItem.style.removeProperty('transform');
                                            navItem.style.removeProperty('opacity');
                                            navItem.style.removeProperty('transition');
                                        });
                                    }, 250)
                                }, 250)
                            }
                        }, index * 50);
                    });
                }, delayForClosingOpenLinkContent)

                
            }
        } else {
            menu.classList.remove(`${menuMobileImprovedClass.replace('STATUS', 'closed')}`);
            menu.classList.remove(`${menuMobileImprovedClass.replace('STATUS', 'open')}`);
            setTimeout(function(){
                menu.setAttribute('data-transitioning', false);
                menu.setAttribute('data-status', `${newStatus}`);
                menu.classList.add(`${menuMobileImprovedClass.replace('STATUS', newStatus)}`);
            }, 250);
        }
    };

    handleMenuAnimation();

    navLinks.forEach((navLink) => {
        navLink.style.pointerEvents = "none";

        let navLinkIcon = navLink.querySelector('.menu-mobile-improved__nav-icon');

        navLinkIcon.classList.remove(`${navLinkIconStatusClass.replace('STATUS', 'closed')}`);
        navLinkIcon.classList.remove(`${navLinkIconStatusClass.replace('STATUS', 'open')}`);
        navLink.setAttribute('data-status', `${newStatus}`);
        navLinkIcon.classList.add(`${navLinkIconStatusClass.replace('STATUS', newStatus)}`);
    
        setTimeout(function () {
            navLink.style.pointerEvents = "";
        }, 250);
    
    });

    // Status and class will be set after animations complete
}

const initMobileMenu = function(){
    if(header){
        header.addEventListener('click', function(event) {
            if (event.target.closest('.menu-mobile-improved__nav-link')) {window.Branch.nav.handleNavLinkClick()}
        });
        header.addEventListener('wheel', function(event){if(mobileDropdown && mobileDropdown.getAttribute('data-status') == 'open'){event.preventDefault()}}, {passive: false});
        header.addEventListener('touchmove', function(event){if(mobileDropdown && mobileDropdown.getAttribute('data-status') == 'open'){event.preventDefault()}}, {passive: false});
    }
    if(slideDown){
        slideDown.addEventListener('click', function(event) {
            if (event.target.closest('.menu-mobile-improved__nav-link')) {window.Branch.nav.handleNavLinkClick()}
        });
        slideDown.addEventListener('wheel', function(event){if(mobileDropdown && mobileDropdown.getAttribute('data-status') == 'open'){event.preventDefault()}}, {passive: false});
        slideDown.addEventListener('touchmove', function(event){if(mobileDropdown && mobileDropdown.getAttribute('data-status') == 'open'){event.preventDefault()}}, {passive: false});
    }
    if(mobileDropdown){
        mobileDropdown.addEventListener('click', function(event) {
            if (event.target.closest('.menu-mobile-improved__close-icon-container')) {
                handleMobileNavItemClick(event, 'click_outside', 0)
            }
        })
    }

    headerOuter.setAttribute('data-mobile-nav-btn-activated', true)

    menuMobileInnerContainer.setAttribute('data-scrolled-to-top', menuMobileInnerContainer.scrollTop === 0)
    menuMobileInnerContainer.addEventListener('scroll', function(){
        menuMobileInnerContainer.setAttribute('data-scrolled-to-top', menuMobileInnerContainer.scrollTop === 0)
    });

    function preventUpwardScroll(event, type) {
        if(!event.target.closest('.menu-mobile-improved__nav-item-link-content') && !event.target.closest('.menu-mobile-improved__loading-stand-in')){
            const scrolledToTop = menuMobileInnerContainer.getAttribute("data-scrolled-to-top") === "true";
            if(type == 'wheel'){
                if (scrolledToTop && event.deltaY < 0) {
                    event.preventDefault();
                }
            } else {
                if (scrolledToTop) {
                    const touch = event.touches[0];
                    if (touch.clientY > menuMobileInnerContainer.lastTouchY) {
                        event.preventDefault(); 
                    }
                }
            }
        }
    }

    menuMobileInnerContainer.addEventListener("wheel", (event) => preventUpwardScroll(event, 'wheel'), { passive: false });
    menuMobileInnerContainer.addEventListener("touchmove", (event) => preventUpwardScroll(event, 'touchmove'), { passive: false });
}

const initNavItemSlider = function(navItemIndex){
      var swiper = new Swiper(`.menu-mobile-improved__sub-nav-items-container[data-item-index="${navItemIndex}"]`, {
        slidesPerView: 2.5,
        spaceBetween: 20,
        freeMode: true
      });
}

const initMobileNavItemState = function(){
    let navItemsWithDropdown = document.querySelectorAll(`.menu-mobile-improved__nav-item--has-dropdown`);
    if(navItemsWithDropdown.length > 0){
        navItemsWithDropdown.forEach((navItemWithDropdown) => {
            navItemWithDropdown.querySelector('.menu-mobile-improved__nav-item-link').addEventListener('click', function(e){
                    handleMobileNavItemClick(e, 'click', parseInt(navItemWithDropdown.getAttribute('data-item-index')))
                }
            )
        initNavItemSlider(navItemWithDropdown.getAttribute('data-item-index'));
        })
    }
}

const copySection = function(type, linkContent, originalElement, data, handle, wrapperClassName){
    const clonedElement = originalElement.cloneNode(true);

    if(type == 'rich-text'){
        clonedElement.querySelectorAll("style").forEach(style => style.remove());
        clonedElement.querySelectorAll(".toggle-header-menu-dropdown__rich-text:not([data-handle='default'])").forEach(el => el.remove());    
    }

    if(type == 'bundles'){
        clonedElement.querySelectorAll(".toggle-header-menu-dropdown__bundle-step-title").forEach(title => title.style.removeProperty("height"));
    }
    
    const wrapper = document.createElement('div');
    wrapper.className = wrapperClassName;

    const seperator = document.createElement('div');
    seperator.className = 'menu-mobile-improved__nav-item-seperator';

    if(type == 'bundles' && data && data.hide_product_list == 'true'){
        const title = document.createElement('div');
        title.className = 'menu-mobile-improved__nav-item-product-link-header';
        title.innerHTML = `${linkContent.closest('.menu-mobile-improved__nav-item').querySelector('.menu-mobile-improved__nav-item-link ').innerHTML}`
        wrapper.appendChild(title);
    }

    wrapper.appendChild(clonedElement);
    linkContent.appendChild(wrapper);
    linkContent.appendChild(seperator);
}

const copyProductList = function(linkContent, handle, productList){
    let lastElement = productList.querySelector(`.toggle-header-products-list__inner-container[data-link-handle="${handle}"]`);
    
    if(!lastElement || lastElement && lastElement.querySelectorAll('.product-tile').length == 0){
        lastElement = productList.querySelector(`.toggle-header-products-list__inner-container:not([data-link-handle="${handle}"])`);
    }

    if (lastElement) {
        const clonedElement = lastElement.cloneNode(true);
        const wrapper = document.createElement('div');
        wrapper.className = 'menu-mobile-improved__nav-item-product-link-container';

        const seperator = document.createElement('div');
        seperator.className = 'menu-mobile-improved__nav-item-seperator';

        const title = document.createElement('div');
        title.className = 'menu-mobile-improved__nav-item-product-link-header';
        title.innerHTML = `${linkContent.closest('.menu-mobile-improved__nav-item').querySelector('.menu-mobile-improved__nav-item-link ').innerHTML}`

        const getRandomId = () => Math.floor(10000 + Math.random() * 90000);

        clonedElement.setAttribute('data-id', getRandomId());
        clonedElement.querySelectorAll('.product-tile').forEach(tile => {
            tile.setAttribute('data-id', getRandomId());
        });
        wrapper.appendChild(title);
        wrapper.appendChild(clonedElement);
        linkContent.appendChild(wrapper);
        linkContent.appendChild(seperator);
    }
}

const copyCta = function(origin, linkContent, cta, type, footerContent){
    const separators = linkContent && origin == 'slide-out' ? linkContent.querySelectorAll('.menu-mobile-improved__nav-item-seperator') : [];
    if (separators.length > 0) {
        separators[separators.length - 1].remove();
    }

    const clonedElement = cta.cloneNode(true);
    clonedElement.querySelector(`.toggle-header-title-bar-container__cta:not([data-type="${type}"])`).remove();

    let chatWithSalesStatus = cta.closest('.toggle-header-title-bar-container__utils-inner') ? cta.closest('.toggle-header-title-bar-container__utils-inner').getAttribute('data-chat-with-sales-display') : undefined;

    const wrapper = document.createElement('div');
    wrapper.className = 'menu-mobile-improved__nav-item-cta-container';
    
    if(chatWithSalesStatus){
        wrapper.setAttribute('data-chat-with-sales-display', chatWithSalesStatus)
    }
    
    

    if (cta.previousElementSibling?.classList.contains('toggle-header-title-bar-container__chat-with-sales-button')){
        wrapper.appendChild(cta.previousElementSibling.cloneNode(true));
    }

    

    wrapper.appendChild(clonedElement);
    if(origin == 'main'){
        wrapper.setAttribute('data-type', type)
    }

    if(footerContent && origin == 'slide-out'  ){
        let clonedFooterContent = footerContent.cloneNode(true)
        clonedFooterContent.querySelector(`.menu-mobile-improved__footer-ctas-container`).remove();
        clonedFooterContent.querySelector(`.menu-mobile-improved__additional-links-container`).remove();
        wrapper.appendChild(clonedFooterContent);
    }

    linkContent.appendChild(wrapper);
    if(origin == 'main' && type == "b2b"){
        const seperator = document.createElement('div');
        seperator.className = 'menu-mobile-improved__nav-item-seperator';
        linkContent.appendChild(seperator);
    }
}

const copyNavSubItems = function(linkContent, navSubItems, data){
    const clonedElement = navSubItems.cloneNode(true);
    if(data && data.sub_menu_items_to_exclude_mobile.length > 0){
        data.sub_menu_items_to_exclude_mobile[0].forEach((sub_menu_item_handle) => {
            clonedElement.querySelectorAll('.toggle-header-menu-bar-container__submenu-item').forEach((submenuItem) => {
                if(submenuItem.getAttribute('data-handle') == sub_menu_item_handle){
                    submenuItem.remove();
                }
            })
        })
    }

    const wrapper = document.createElement('div');
    wrapper.className = 'menu-mobile-improved__nav-item-sub-items-container';

    const seperator = document.createElement('div');
    seperator.className = 'menu-mobile-improved__nav-item-seperator';

    const submenuItems = Array.from(clonedElement.querySelectorAll('[data-sub-menu-items-layout="sub-menu-items-and-sub-sub-menu-items"] .toggle-header-menu-bar-container__submenu-item'));


    if (submenuItems.length > 0) {
        const newContainer = document.createDocumentFragment();

        for (let i = 0; i < submenuItems.length; i += 2) {
            const container = document.createElement('div');
            container.className = 'toggle-header-menu-bar-container__submenu-item-container';
            container.appendChild(submenuItems[i]);
            if (submenuItems[i + 1]) {
                container.appendChild(submenuItems[i + 1]);
            }
            newContainer.appendChild(container);

            if (i + 2 < submenuItems.length) {
                newContainer.appendChild(seperator.cloneNode(true));
            }
        }

        clonedElement.querySelector('.toggle-header-menu-bar-container__submenu').innerHTML = '';
        clonedElement.querySelector('.toggle-header-menu-bar-container__submenu').appendChild(newContainer);
    }

    wrapper.appendChild(clonedElement);
    linkContent.appendChild(wrapper);
    linkContent.appendChild(seperator);
}

const initUtilityBarLinks = function(){
    mobileMenuFooter.addEventListener('click', function(event){
        if(event.target.closest('.utility-bar__link-anchor')){
            let anchor = event.target.closest('.utility-bar__link-anchor');
            event.preventDefault();
            let newStatus = anchor.closest('.menu-mobile-improved__utility-link').getAttribute('data-status') == 'open' ? 'closed' : 'open';
            document.querySelectorAll('.menu-mobile-improved__utility-link').forEach((utilityLink) => {utilityLink.setAttribute('data-status', 'closed')});
            anchor.closest('.menu-mobile-improved__utility-link').setAttribute('data-status', `${newStatus}`)
        }
    })
}

const copyUtilityBarLinks = function(){
    let utilityLinksContainer = document.querySelector('.menu-mobile-improved__additional-links-container');
    let originalUtilityBarLinks = document.querySelectorAll('.utility-bar__links .upper-menu-item');
    const utilityLinks = document.createElement('ul');
    utilityLinks.className = 'menu-mobile-improved__utility-links';
    originalUtilityBarLinks.forEach((originalUtilityBarLink, index) => {
        const utilityLinkTopLevel = document.createElement('li');
        utilityLinkTopLevel.className = 'menu-mobile-improved__utility-link';
        utilityLinkTopLevel.setAttribute('data-status', 'closed');

        let clonedInnerLink = originalUtilityBarLink.querySelector('.utility-bar__link').cloneNode(true);
        clonedInnerLink.setAttribute('data-index', index);
        clonedInnerLink.className = 'utility-bar__link-anchor'
        utilityLinkTopLevel.appendChild(clonedInnerLink)

        const clonedSubLinkItems = document.createElement('ul');
        clonedSubLinkItems.innerHTML = originalUtilityBarLink.querySelector('.upper-menu-item-children').cloneNode(true).innerHTML;
        clonedSubLinkItems.className = 'menu-mobile-improved__utility-sub-links';
        clonedSubLinkItems.style.height = `${clonedSubLinkItems.children.length * 25.2}px`;

        Array.from(clonedSubLinkItems.children).forEach(child => {
            const li = document.createElement('li');
            li.appendChild(child.querySelector('a').cloneNode(true));
            li.className = 'menu-mobile-improved__utility-sub-link'
            child.replaceWith(li);
        });

        utilityLinkTopLevel.appendChild(clonedSubLinkItems)
        utilityLinks.appendChild(utilityLinkTopLevel);
    });
    
    utilityLinksContainer.appendChild(utilityLinks);

    if(document.querySelector('.utility-bar__link#friendbuyoverlay')){
        utilityLinksContainer.appendChild(document.querySelector('.utility-bar__link#friendbuyoverlay').cloneNode(true))
    }

    initUtilityBarLinks();
}

const tileOnTouchStart = function(e){
    if(e.target.closest(".product-tile__main-link") || e.target.closest(".toggle-header__smart-search-popular-categories-item-link")){
        swipedTile = e.target.closest(".product-tile__main-link") ? e.target.closest(".product-tile__main-link") : e.target.closest(".toggle-header__smart-search-popular-categories-item-link");
        swipedTile.dataset.startY = e.touches[0].clientY;
        swipedTile.dataset.isSwipeUpDown = "false";
        console.log('on')
    }   
}

const tileOnTouchMove = function(e){
    if(swipedTile){
        if(e.target.closest(".product-tile__main-link") || e.target.closest(".toggle-header__smart-search-popular-categories-item-link")){
            let diff = e.touches[0].clientY - swipedTile.dataset.startY;
            if (Math.abs(diff) > 20) {
                swipedTile.dataset.isSwipeUpDown = "true";
            }
        }
    }
}

const initProductTileSwipeDownClickPrevent = function(){
    mobileDropdown.addEventListener("touchstart", (e) => {
        tileOnTouchStart(e);
    });
    
    mobileDropdown.addEventListener("touchmove", (e) => {
        tileOnTouchMove(e)
    });

    allSearchDropdowns.forEach((searchDropdown) => {
        searchDropdown.addEventListener("touchstart", (e) => {
            tileOnTouchStart(e);
        });
        
        searchDropdown.addEventListener("touchmove", (e) => {
            tileOnTouchMove(e)
        });
    })
}

const copyDesktopContentToMobile = function(){
    let allMobileNavItems = document.querySelectorAll('.menu-mobile-improved__nav-item.menu-mobile-improved__nav-item--has-dropdown');
    let toggleCtas = document.querySelectorAll('.toggle-header-title-bar-container__ctas');
    let footerContent = document.querySelector('.menu-mobile-improved__footer');
    let closeButtonHTML = `<div class="menu-mobile-improved__close-icon-container"><button aria-label="Close opened sub menu" class="menu-mobile-improved__close-icon-button"><svg aria-hidden="false" tabindex="-1" role="presentation" class="transition icon icon-arrow-left left-arrow" viewBox="0 0 32 32"><path fill="#98a19c" d="M12.6354 16L26 3.555L22.1823 0L5 16L22.1823 32L26 28.445L12.6354 16Z"></path></svg><span>Back</span></button></div>`;

    ['dtc', 'b2b'].forEach((type, index) => {
        let cta = toggleCtas[index];
        let linkContent = document.querySelector('.menu-mobile-improved__footer-ctas-container');
        copyCta('main', linkContent, cta, type, footerContent);
    });


    copyUtilityBarLinks();


    allMobileNavItems.forEach((mobileNavItem) => {
        let linkContent = mobileNavItem.querySelector('.menu-mobile-improved__nav-item-link-content');
        let type = mobileNavItem.getAttribute('data-item-type');
        let name = mobileNavItem.getAttribute('data-menu-name');
        let data = toggleHeaderData[`${name}___${type}`]
        let cta = toggleCtas[0];
        let equivalentDesktopContent = document.querySelector(`.toggle-header-menu-bar-container[data-type="${type}"] .toggle-header-menu-bar-container__item[data-parent="${name}"] .toggle-header-menu-dropdown, .toggle-header__slide-down-nav-container[data-type="${type}"] .toggle-header-menu-bar-container__item[data-parent="${name}"] .toggle-header-menu-dropdown`)
        if(equivalentDesktopContent){

            linkContent.insertAdjacentHTML('afterbegin', closeButtonHTML);

            let productList = equivalentDesktopContent.querySelector('.toggle-header-menu-dropdown__products-list-outer-container');
            if(productList){
                if(data && data.hide_product_list == 'false'){
                    copyProductList(linkContent, 'default', productList);
                    if(name == 'sale'){
                    }
                }
                if(data && data.additional_product_lists_for_mobile.length > 0){
                    data.additional_product_lists_for_mobile[0].forEach((additional_list) => {
                        copyProductList(linkContent, `${additional_list}`, productList);
                    })
                }
            }

            let bundleSection = equivalentDesktopContent.querySelector('.toggle-header-menu-dropdown__bundle-steps-outer-container');
            if(bundleSection){
                copySection('bundles', linkContent, bundleSection, data, null, 'menu-mobile-improved__nav-item-bundles-container')
            }

            let navSubItems = equivalentDesktopContent.querySelector('.toggle-header-menu-dropdown__submenu-container');
            if(navSubItems){
                copyNavSubItems(linkContent, navSubItems, data);
            }

            let richTextSection = equivalentDesktopContent.querySelector('.toggle-header-menu-dropdown__rich-text-outer-container');
            
            if(richTextSection){
                copySection('rich-text', linkContent, richTextSection, data, null, 'menu-mobile-improved__nav-item-rich-text-container')
            }

            let logoSection = equivalentDesktopContent.querySelector('.toggle-header-menu-dropdown__logos-element-outer-container');
            if(logoSection){
                copySection('logos', linkContent, logoSection, data, null, 'menu-mobile-improved__nav-item-logos-container')
            }

            copyCta('slide-out', linkContent, cta, type, footerContent);
        }
    })
    mobileDropdown.setAttribute('data-all-content-copied', true);
    setTimeout(() => {
        updateSubMenuItemHeights();
        mobileDropdown.querySelectorAll('.menu-mobile-improved__nav-item').forEach((currentItemDropdown) => {
            if(currentItemDropdown.getAttribute('data-carousels-initialized') == 'false'){                
                initProductCarousels(currentItemDropdown, 'regular');
            }
        });
        document.querySelectorAll('.menu-mobile-improved__nav-item-content-stand-in-wrapper').forEach((standInWrapper) => {standInWrapper.style.display = 'none'});
    }, 500)
}

const initUtilityBarObserver = function(){
    let utilityBar = document.querySelector(`#header .utility-bar`);
    let mutating = false;

    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === "attributes" && mutating == false) {
                mutating = true;
                updateMenuPosition('utility-bar-close')
                setTimeout(function() {
                    mutating = false;
                }, 500);
            }
        });
    });

    if(utilityBar){
        observer.observe(utilityBar, {attributes: true});
    }
}

const initSearchDropDown = function(){
    allSearchDropdowns = document.querySelectorAll('.toggle-header__smart-search-dropdown-outer');
    allSearchDropdowns.forEach((searchDropdown) => {
        if(searchDropdown.querySelector('.toggle-header__smart-search-popular-categories-carousel').getAttribute('data-initialized') != 'true'){
            searchDropdown.querySelector('.toggle-header__smart-search-popular-categories-carousel').setAttribute('data-initialized', true)
            initProductCarousels(searchDropdown, 'search');
        }
    })
}

window.Branch.nav.handleToggleHeaderScroll = function(scrollContainer) {
    let prevSlideDownVisible = slideDownVisible == true;
    let bundleBuilderSlideDownPricing = document.querySelector('.bundle-builder__slide-down-pricing');
    let closeTimeout = bundleBuilderSlideDownPricing ? 250 : 0;

    if(reusableVariablesInitialized == false) {
        initToggleHeaderReusableVariableDeclarations();
    }

    if(bundleBuilderSlideDownPricing && slideDownPrice){
        let headerHeight = document.querySelector('.toggle-header__slide-down-container .toggle-header__slide-down-header') ? document.querySelector('.toggle-header__slide-down-container .toggle-header__slide-down-header').offsetHeight : 0;
        slideDownPrice.style.top = `${headerHeight}px`
    }

    let scrollY = window.scrollY;
    

    if (scrollY > scrollThreshold) {
        const result = window.Branch.functions.isElementPartiallyOffScreen('.toggle-header__menu-bar');

        if (result) {
            slideDown.style.transform = `translateY(0)`;
            slideDown.style.height = `0`;
            repositionNavItems(true, result);
            slideDownVisible = true;
            if(bundleBuilderSlideDownPricing){bundleBuilderSlideDownPricing.style.display = 'block'};
            if(bundleBuilderSlideDownPricing){setTimeout(() => {bundleBuilderSlideDownPricing.setAttribute('data-active', true)}, 250); window.Branch.bundle.shiftSlideDownContent('open');};
        } else {
            if(bundleBuilderSlideDownPricing){bundleBuilderSlideDownPricing.setAttribute('data-active', false); window.Branch.bundle.shiftSlideDownContent('close');}
            setTimeout(() => {
                const heightValue = slideDownLayout == 'nav_items_bar_and_header_bar' ? 60 + titleBar.offsetHeight : 60;
                slideDown.style.transform = `translateY(-${heightValue}px)`;
                slideDown.style.height = `${heightValue}px`;
                repositionNavItems(false, result);
                slideDownVisible = false;
                if(bundleBuilderSlideDownPricing){bundleBuilderSlideDownPricing.style.display = 'none'};
            }, closeTimeout) 
        }
    } else {
        if(bundleBuilderSlideDownPricing){bundleBuilderSlideDownPricing.setAttribute('data-active', false); window.Branch.bundle.shiftSlideDownContent('close');};
        setTimeout(() => {
            const heightValue = slideDownLayout == 'nav_items_bar_and_header_bar' ? 60 + titleBar.offsetHeight : 60;
            slideDown.style.transform = `translateY(-${heightValue}px)`;
            slideDown.style.height = `${heightValue}px`;
            repositionNavItems(false, false);
            slideDownVisible = false;
            if(bundleBuilderSlideDownPricing){bundleBuilderSlideDownPricing.style.display = 'none'};
        }, closeTimeout) 

    }
    if(prevSlideDownVisible != slideDownVisible){
        closeAllSearchContainers();
    }

    productPageStickyAtcCheck();
    updateMenuPosition();
}

const fetchSearchResults = function (value, e, signal) {
    const urlToFetch = `/search?q=${encodeURIComponent(value)}&view=smart&filter.p.m.custom.current=true`;
    fetch(urlToFetch, { cache: 'no-store', signal })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
    })
    .then(data => {
    if (signal.aborted) return;          // guard for any async after the fetch
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, 'text/html');
      if(document.querySelector('.products--list .toggle-header__smart-search-no-matching-results')){document.querySelector('.products--list .toggle-header__smart-search-no-matching-results').remove()}

      let newGrid = doc.querySelector('.grid');
      if (!newGrid || newGrid.querySelectorAll('.product-tile').length == 0)  {
          newGrid = document.createElement("div");
          newGrid.innerHTML = `<h4 class="toggle-header__smart-search-no-matching-results">No results for "${value}"</h4>`
      }


      document.querySelectorAll('.toggle-header__smart-search-dropdown-outer').forEach((dropDownOuter, dropDownOuterIndex) => {
        const currentGrid = dropDownOuter.querySelector('.grid');
        if (!currentGrid) {
              throw new Error('.products--list .grid element not found on the current page.');
        }

        if(newGrid.querySelectorAll('.product-tile').length == 0){
            dropDownOuter.querySelector('.toggle-header__smart-search-results-see-all').setAttribute('data-visible', `false`);
        } else {
            dropDownOuter.querySelector('.toggle-header__smart-search-results-see-all').setAttribute('data-visible', `true`);
        }

        newGrid.querySelectorAll('.product-tile').forEach((productTile) => {
            productTile.classList.add('swiper-slide')
            let productImage = productTile.querySelector('.product-image');
            let labelText = productImage.getAttribute('data-swatch-text');
            let labelHTML = null;
            let handle = productImage.getAttribute('data-handle')
            if(labelText && labelText != ''){
                labelHTML = `<div data-sale-text="${labelText}" class="sale" data-display="true">${labelText}</div>`
            } else {
                let originalPrice = 0;
                let currentPrice = 0;
                let legacyBundle = productImage.getAttribute('data-legacy-bundle') == 'true';
                let presetBundle = productImage.getAttribute('data-preset-bundle') == 'true'
                if(legacyBundle || presetBundle){
                    let selector = `${legacyBundle ? `.per-variant-pricing[data-product-handle="${handle}"]` : `.preset_bundle_price_data[data-product-handle="${handle}"]`}`
                    let priceDataElement = productTile.querySelector(selector);
                    if(priceDataElement){
                        let priceData = JSON.parse(priceDataElement.innerText)
                            let variantPriceData = legacyBundle ? Object.values(priceData)[0] : priceData;
                            let constituents = legacyBundle ? variantPriceData['constituents'] : Object.entries(variantPriceData).map(([handle, { price, original_price }]) => ({handle, price, compare_at_price: original_price }));
                            if(constituents){
                                let bundleDiscountAmount = 5;
                                if(handle == "cable-organizer" || handle == "open-box-cable-organizer"){bundleDiscountAmount = 0};
                                constituents.forEach((constituent) => {
                                let codeDiscountData = window.Branch.functions.returnDiscountCodeUpdates(parseInt(constituent.price) * parseInt(legacyBundle ? constituent.quantity : 1), parseInt(constituent.compare_at_price) * parseInt(legacyBundle ? constituent.quantity : 1), 0, '', constituent.handle);
                                let codeDiscountAmountPercentage = codeDiscountData['discountAmount'] > 0 ? ((codeDiscountData.originalPrice - codeDiscountData.currentPrice) / codeDiscountData.originalPrice) * 100 + bundleDiscountAmount : 0 + bundleDiscountAmount;
                                
                                let constituentQuantity = constituent.quantity ? constituent.quantity : 1;
                                let amountToAddToCurrentPrice = (parseInt(constituent.price) * ((100 - codeDiscountAmountPercentage)/ 100) * constituentQuantity);

                                originalPrice = originalPrice + codeDiscountData.originalPrice;
                                currentPrice = currentPrice + amountToAddToCurrentPrice;
                            })
                        }
                    } 
                } else {
                    let codeDiscountData = window.Branch.functions.returnDiscountCodeUpdates(parseInt(productImage.getAttribute('data-first-variant-price')), parseInt(productImage.getAttribute('data-first-variant-compare-price')), 0, '', handle);
                    originalPrice = codeDiscountData.originalPrice;
                    currentPrice = codeDiscountData.currentPrice;  
                }

                if(originalPrice > currentPrice){
                    
                    let percentageDiscount = Math.round(100 * ((originalPrice - currentPrice) / originalPrice));
                    labelHTML = `<div data-sale-text="Save ${percentageDiscount}%" class="sale" data-display="true">Save ${percentageDiscount}%</div>`
                }
            }
            if(labelHTML){
                productImage.querySelectorAll('.sale').forEach((label) => {label.remove()});
                productImage.insertAdjacentHTML('afterbegin', labelHTML) 
            }
        })
        

        currentGrid.innerHTML = newGrid.innerHTML;
        currentGrid.parentElement.setAttribute('data-index', dropDownOuterIndex);

        document.querySelectorAll('.toggle-header-title-bar-container__search-container').forEach((searchContainer) => {
            searchContainer.querySelector('.toggle-header__smart-search-results-see-all').setAttribute('href', `/search?q=${value}&filter.p.m.custom.current=true`);
            if (!searchContainer.contains(e.target)) {
                searchContainer.querySelector('input[type="search"]').value = value;
              }
        });

        
      })

    })
    .then(data => {
        if (signal.aborted) return;
        document.querySelectorAll('.toggle-header__smart-search-dropdown-outer').forEach((dropDownOuter) => {
            dropDownOuter.setAttribute('data-search-results-displayed', true);
            searchResultsDisplayed = true;
            dropDownOuter.setAttribute('data-search-updating', false);
        });
        return new Promise(resolve => setTimeout(resolve, 2000));
    })
    .then(data => {
        if (signal.aborted) return;
        let params = returnSwiperParams('search-results', '', '');
        for(i = 0; i < 2; i++){
            var toggleHeaderSwiper = new Swiper(`.toggle-header__smart-search-results-container[data-index="${i}"]`, params);
        }
    })
    .catch(error => {
        if (error && error.name === 'AbortError') return; // silent on purposeful abort
        console.error('Error fetching data:', error);

    });
}

const smartSearchInputDelay = function(searchInput, e){
    allSearchDropdowns.forEach((searchDropdown) => {
        if(prevSearchInput == ''){
            searchDropdown.setAttribute('data-search-results-displayed', false);
            searchResultsDisplayed = false;
            searchDropdown.setAttribute('data-search-updating', true);
        }
    });
    clearTimeout(smartSearchTimer);
    currentAbortCtrl?.abort();           


    smartSearchTimer = setTimeout(() => {
        prevSearchInput = searchInput.value;
        if(searchInput.value != ''){
            currentAbortCtrl = new AbortController();
            const { signal } = currentAbortCtrl;

            fetchSearchResults(searchInput.value, e, signal);
        } else {
            allSearchDropdowns.forEach((searchDropdown) => {
                searchDropdown.setAttribute('data-search-results-displayed', false);
                searchResultsDisplayed = false;
                searchDropdown.setAttribute('data-search-updating', false);

            });
        }
    }, 200);
}

const initSmartSearch = function(){
    let searchInputs = headerOuter.querySelectorAll('.toggle-header-title-bar-container__search-container input[type="search"]'); 
    searchInputs.forEach((searchInput) => {
        searchInput.addEventListener('input', function(e){
            smartSearchInputDelay(searchInput, e);
        });
    });

    document.addEventListener('click', function (event) {
        const link = event.target.closest('.toggle-header__smart-search-sub-menu-link:not([data-special-link="true"])');
        if (!link) return; 
      
        event.preventDefault();
        const container = link.closest('.toggle-header-title-bar-container__search-container');
        if (!container) return;
        const input = container.querySelector('input[type="search"]');
        if (!input) return;
        const span = link.querySelector('span');
        input.value = span.textContent.trim();
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });

      document.addEventListener('submit', function(e) {
        e.preventDefault();
        const form = e.target.closest('.toggle-header-title-bar-container__search-container') && e.target.closest('.toggle-header-title-bar-container__search-container').querySelector('form[role="search"]');
        if(!form) return;
        if(form.querySelector('input[type="search"]')){
            let value = form.querySelector('input[type="search"]').value
            if(value.trim() === '') {
                return;
            }
            const urlToFetch = `/search?q=${encodeURIComponent(value)}&filter.p.m.custom.current=true`;
            window.location.href = urlToFetch;
        } 
      });
    
      document.addEventListener('keydown', function (e) {
        const form = e.target.closest('.toggle-header-title-bar-container__search-container') && e.target.closest('.toggle-header-title-bar-container__search-container').querySelector('form[role="search"]');
        if(!form) return;
        if (e.key === 'Enter') {
            if (smartSearchActive && form.closest('.toggle-header-title-bar-container__search-container') && form.closest('.toggle-header-title-bar-container__search-container').querySelector('.toggle-header__smart-search-dropdown-outer') && form.closest('.toggle-header-title-bar-container__search-container').querySelector('.toggle-header__smart-search-dropdown-outer').getAttribute('data-search-updating') == 'true') {
              e.preventDefault();
            } else {
                if(form.querySelector('input[type="search"]')){
                    e.preventDefault();
                    let value = form.querySelector('input[type="search"]').value;
                    if(value.trim() === '') {
                        return;
                    }
                    const urlToFetch = `/search?q=${encodeURIComponent(value)}&filter.p.m.custom.current=true`;
                    window.location.href = urlToFetch;
                } 
            }
          }
      });      
}

function initUtilityBar(){
    if(document.querySelector('.toggle-header__utility-bar') && document.querySelector('.toggle-header__utility-bar').getAttribute('data-multiple-messages') == 'true'){
        for (let i = 0; i < 2; i++) {
            let selector = i == 0 ? '.toggle-header__utility-bar:not(.mobile) .utility-bar__message-container' : '.toggle-header__utility-bar.mobile .utility-bar__message-container'
            let outerSelector = i == 0 ? '.toggle-header__utility-bar:not(.mobile)' : '.toggle-header__utility-bar.mobile';
            let enable_autoscroll = document.querySelector(`${selector}`).getAttribute('data-enable-autoscroll') == 'true';
            let autoscroll_interval = 1000 * parseInt(document.querySelector(`${selector}`).getAttribute('data-autoscroll-interval'));
            let autoplay = !enable_autoscroll ? false : {delay: autoscroll_interval, disableOnInteraction: true}


            utilityBarSwipers[`swiper-${i}`] = new Swiper(`${selector}`, {
                slidesPerView: 1,
                spaceBetween: 0,
                autoplay: autoplay,
                freeMode: false,
                loop: true,
                navigation: {
                    nextEl: `${outerSelector} .toggle-header__utility-bar-nav-right`,
                    prevEl: `${outerSelector} .toggle-header__utility-bar-nav-left`,
                },
            });
        }


    }
}

function initUtilityBarCountdown(){
    const dataScript = document.getElementById('doorbusters-utility-bar-data');
    if (!dataScript) return;

    let doorbustersData;
    try {
        doorbustersData = JSON.parse(dataScript.textContent);
    } catch (error) {
        console.error('Failed to parse doorbusters utility bar data:', error);
        return;
    }

    const countdownElements = document.querySelectorAll('.utility-bar__countdown');
    if (countdownElements.length === 0) return;

    const getCurrentEasternTime = () => {
        return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
    };

    const currentTime = getCurrentEasternTime();
    let currentDoorbuster = null;

    // Find the current active doorbuster
    for (const doorbuster of doorbustersData.doorbusters) {
        const startTime = new Date(new Date(doorbuster.start_time).toLocaleString('en-US', { timeZone: 'America/New_York' }));
        const endTime = new Date(new Date(doorbuster.end_time).toLocaleString('en-US', { timeZone: 'America/New_York' }));

        if (currentTime >= startTime && currentTime <= endTime) {
            currentDoorbuster = doorbuster;
            break;
        }
    }

    if (!currentDoorbuster) return;

    const endTime = new Date(new Date(currentDoorbuster.end_time).toLocaleString('en-US', { timeZone: 'America/New_York' }));

    const updateCountdown = () => {
        const currentEasternTime = getCurrentEasternTime();
        const timeDiff = endTime - currentEasternTime;

        if (timeDiff <= 0) {
            countdownElements.forEach((element) => {
                element.textContent = '00:00:00';
            });
            clearInterval(countdownInterval);
            return;
        }

        const hours = Math.floor(timeDiff / (1000 * 60 * 60));
        const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
        const formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

        countdownElements.forEach((element) => {
            element.textContent = formattedTime;
        });
    };

    const countdownInterval = setInterval(updateCountdown, 1000);
    updateCountdown();
}

const initTilePricing = function(){
    let allTilesPrices = document.querySelectorAll('#shopify-section-header .product-tile .price');
    allTilesPrices.forEach((tilePrice) => {
        let preSetBundle = tilePrice.closest('.product-tile__info-container') && tilePrice.closest('.product-tile__info-container').getAttribute('data-bundle-builder-product') == 'true';
        let handle = tilePrice.getAttribute('data-product-handle');
        let priceData = preSetBundle && document.querySelector(`.preset_bundle_price_data[data-product-handle="${handle}"]`) ? JSON.parse(document.querySelector(`.preset_bundle_price_data[data-product-handle="${handle}"]`).innerText) : {};
        let productTile = tilePrice.closest('.product-tile');
        let tileType = preSetBundle ? 'preset_bundle' : 'regular';
        window.Branch.collection.updateDisabledSwatchedPrice(productTile, priceData, tileType, null, null);
    })
}

const initFunctionsOnInteract = function(){
    initLinkHoverListeners();
    initProductTileSwipeDownClickPrevent();
    initRichTextLinks();
    initTilePricing();
}

window.addEventListener('mousemove', toggleHeaderDebounce((e) => {
    if(header){
        if(touchDevice == false){
            handleMouseMove(e, true);
        }
    }
}, 250), { once: true });

window.addEventListener("DOMContentLoaded", function() {
    initToggleHeaderReusableVariableDeclarations();
    if(header){
        updateStyling();
        initMobileMenu();
        initToggleElement();
        toggleFromSessionHistory();
        initAllDropDowns();
        initSearchButton();
        headerOuter.querySelectorAll('.toggle-header-title-bar-container__search-container').forEach((searchContainer) => {searchContainer.style.removeProperty('pointer-events')});
        essentialTasksComplete = true;
    }
});

window.addEventListener('DOMContentLoaded', function() {
    if(window.innerWidth < 900){
        let interval = setInterval(function() {
            if (header && reusableVariablesInitialized == true) {
                clearInterval(interval);
                desktopContentCopiedToMobile = true;
                copyDesktopContentToMobile();
            }
        }, 100);
    }
});

window.addEventListener('load', function() {
    let interval = setInterval(function() {
        if (header && reusableVariablesInitialized == true && essentialTasksComplete == true) {
            clearInterval(interval);
            if(!touchDevice){
                initTopLevelAnchorTags();
            }
            initMobileNavItemState();
            displayHideToast();
            initUtilityBar();
            initUtilityBarCountdown();
            initUtilityBarObserver();
            productPageStickyAtcCheck();
        }
    }, 100);
});

window.addEventListener('resize', () => {
    if(reusableVariablesInitialized == false){
        initToggleHeaderReusableVariableDeclarations()
    }
    if(header){
        if(toggleHeaderWindowWidth > 899 && window.innerWidth < 900 || toggleHeaderWindowWidth < 900 && window.innerWidth > 899){
            headerOuter.style.opacity = '0'
        }
        if(window.innerWidth < 900 && desktopContentCopiedToMobile == false){
            desktopContentCopiedToMobile = true;
            copyDesktopContentToMobile();
        }
    }
});

window.addEventListener('resize', () => {
    if(header){
        clearTimeout(toggleHeaderResizeTimeout);
        toggleHeaderResizeTimeout = setTimeout(() => {
        if(toggleHeaderWindowWidth != window.innerWidth){
            closeAllSearchContainers();
            updateStyling();   
            toggleHeaderWindowWidth = window.innerWidth;
            setTimeout(() => {
                headerOuter.style.opacity = '1'
            }, 300)
        }
        }, 200); 
    }
});

window.addEventListener('scroll', toggleHeaderDebounce(() => {
    if(header){
        window.Branch.nav.handleToggleHeaderScroll();
    }
}, 200));
